import { Injectable } from '@angular/core';
import { gql } from 'apollo-angular';

import { ApiQuery } from 'infrastructure/common/model/api.query';

export interface CountUserModulePushesByStatusParams {
	readonly userId: string;
}

@Injectable({ providedIn: 'root' })
export class CountUserModulePushesByStatusApiQuery extends ApiQuery<
	{ [key: string]: number },
	CountUserModulePushesByStatusParams
> {
	client = 'messaging';
	document = gql`
		query CountUserModulePushesByStatus($userId: UUID!) {
			countUserModulePushesByStatus(userId: $userId)
		}
	`;
	method = 'countUserModulePushesByStatus';
}
